(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lekka-choose-your-finish"] && !Shopify.designMode) return;
  try {
    
(()=>{
const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const init=(root=document)=>root.querySelectorAll('.lkf .lk-mat__item').forEach(item=>{
  if(item.dataset.lkInit)return;item.dataset.lkInit='1';
  const stage=item.querySelector('.lk-mat__stage');if(!stage)return;
  const s=item.style;
  // cur = what is on screen, tgt = where the pointer wants it; each frame eases cur towards tgt
  const cur={x:.5,y:.4,o:0,t:0},tgt={x:.5,y:.4,o:0,t:0};
  let rect=null,raf=0;
  const paint=()=>{
    const k=.32;let moving=false;
    for(const p in cur){const d=tgt[p]-cur[p];if(Math.abs(d)>.001){cur[p]+=d*k;moving=true}else cur[p]=tgt[p]}
    s.setProperty('--x',(cur.x*100).toFixed(2)+'%');
    s.setProperty('--y',(cur.y*100).toFixed(2)+'%');
    s.setProperty('--px',(130-cur.x*160).toFixed(2)+'%');
    s.setProperty('--rx',((cur.x-.5)*24*cur.t).toFixed(2)+'deg');
    s.setProperty('--ry',(-(cur.y-.5)*18*cur.t).toFixed(2)+'deg');
    s.setProperty('--o',cur.o.toFixed(3));
    s.setProperty('--sc',(1+.03*cur.t).toFixed(4));
    raf=moving?requestAnimationFrame(paint):0;
  };
  const kick=()=>{if(!raf)raf=requestAnimationFrame(paint)};
  const move=(cx,cy)=>{
    if(!rect)rect=stage.getBoundingClientRect();
    tgt.x=Math.min(1,Math.max(0,(cx-rect.left)/rect.width));
    tgt.y=Math.min(1,Math.max(0,(cy-rect.top)/rect.height));
    kick();
  };
  stage.addEventListener('pointerenter',e=>{
    rect=stage.getBoundingClientRect();
    tgt.o=1;tgt.t=(reduce||e.pointerType==='touch')?0:1;
    move(e.clientX,e.clientY);
  });
  stage.addEventListener('pointermove',e=>move(e.clientX,e.clientY),{passive:true});
  const leave=()=>{rect=null;tgt.o=0;tgt.t=0;tgt.x=.5;tgt.y=.4;kick()};
  stage.addEventListener('pointerleave',leave);
  stage.addEventListener('pointercancel',leave);
  window.addEventListener('scroll',()=>{rect=null},{passive:true});
  window.addEventListener('resize',()=>{rect=null},{passive:true});
});
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init()):init();
document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lekka-coaster-picker"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(cents, fmt){
    var v = (cents/100).toFixed(2), whole = v.replace(/\.00$/, '');
    return (fmt || '{'+'{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, whole);
  }
  function init(root){
    if(!root || root.__lkc) return; root.__lkc = true;
    var cfgEl = root.querySelector('[data-lkc-cfg]'); if(!cfgEl) return;
    var C = JSON.parse(cfgEl.textContent);
    var bar = root.querySelector('[data-bar]'); if(!bar) return;
    var tiles = [].slice.call(root.querySelectorAll('.lkc-tile'));
    var countEl = bar.querySelector('[data-count]'), totalEl = bar.querySelector('[data-total]');
    var addBtn = bar.querySelector('[data-add]'), msg = bar.querySelector('[data-msg]');
    var panel = bar.querySelector('[data-panel]'), list = bar.querySelector('[data-list]');
    var done = bar.querySelector('[data-done]'), doneText = bar.querySelector('[data-done-text]');
    var toggle = bar.querySelector('[data-toggle]'), badge = bar.querySelector('[data-badge]'), bag = bar.querySelector('.lkc-bag');
    function esc(v){ return String(v==null?'':v).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

    function selected(){ return tiles.filter(function(t){ return t.getAttribute('aria-pressed') === 'true'; }); }
    function setPanel(open){
      panel.hidden = !open; toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function render(){
      var sel = selected(), n = sel.length;
      var total = sel.reduce(function(a,t){ return a + (+t.dataset.price || 0); }, 0);
      var unit = sel.length ? (+sel[0].dataset.price || 0) : (+(tiles[0] && tiles[0].dataset.price) || 0);
      badge.textContent = n;
      countEl.textContent = n ? (n === 1 ? C.one : C.many).replace('[count]', n) : C.empty;
      totalEl.textContent = n ? money(total, C.moneyFormat) : (unit ? C.each.replace('[price]', money(unit, C.moneyFormat)) : '');
      addBtn.disabled = n === 0; addBtn.textContent = C.button;
      list.innerHTML = sel.map(function(t, i){
        var lab = t.dataset.label || t.dataset.title, num = lab.length <= 3;
        var thumb = t.dataset.img ? '<img src="'+esc(t.dataset.img)+'" alt="">' : esc(lab);
        return '<li class="lkc-row"><span class="lkc-thumb'+(num && !t.dataset.img ? ' lkc-thumb--num' : '')+'" style="--sw:'+esc(t.dataset.bg)+';--sw-ink:'+esc(t.dataset.ink)+'">'+thumb+'</span>'+
          '<span class="lkc-row__name">'+esc(t.dataset.title)+'</span><span class="lkc-row__price">'+money(+t.dataset.price||0, C.moneyFormat)+'</span>'+
          '<button type="button" class="lkc-x" data-i="'+i+'" aria-label="'+esc(C.remove.replace('[name]', t.dataset.title))+'"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button></li>';
      }).join('');
      if(!n) setPanel(false);
    }
    function update(){ done.hidden = true; msg.textContent = ''; render(); bag.classList.remove('bump'); void bag.offsetWidth; bag.classList.add('bump'); }
    tiles.forEach(function(t){
      t.addEventListener('click', function(){
        if(t.disabled) return;
        t.setAttribute('aria-pressed', t.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        update();
      });
    });
    list.addEventListener('click', function(e){
      var x = e.target.closest('.lkc-x'); if(!x) return;
      var t = selected()[+x.dataset.i]; if(t){ t.setAttribute('aria-pressed','false'); update(); }
    });
    toggle.addEventListener('click', function(){ if(selected().length) setPanel(panel.hidden); });
    bar.querySelector('[data-clear]').addEventListener('click', function(){
      tiles.forEach(function(t){ t.setAttribute('aria-pressed','false'); }); update();
    });

    // Category tabs
    var tabs = [].slice.call(root.querySelectorAll('.lkc-tab'));
    var groups = [].slice.call(root.querySelectorAll('.lkc-group'));
    tabs.forEach(function(b){
      b.addEventListener('click', function(){
        tabs.forEach(function(x){ x.setAttribute('aria-pressed', x === b); });
        var f = b.dataset.filter;
        groups.forEach(function(g){ g.hidden = !(f === 'all' || g.dataset.group === f); });
      });
    });

    addBtn.addEventListener('click', function(){
      var sel = selected(); if(!sel.length) return;
      if(sel.some(function(t){ return t.hasAttribute('data-demo'); })){ setPanel(true); msg.textContent = C.demo; return; }
      addBtn.disabled = true; addBtn.textContent = C.adding; msg.textContent = '';
      var drawer = document.querySelector('cart-drawer');
      var n = sel.length, total = sel.reduce(function(a,t){ return a + (+t.dataset.price || 0); }, 0);
      var body = { items: sel.map(function(t){ return { id: +t.dataset.variant, quantity: 1 }; }),
        sections: drawer ? C.drawerSections : 'cart-icon-bubble', sections_url: window.location.pathname };
      fetch(C.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(r){
        return r.json().then(function(j){ if(!r.ok) throw new Error(j.description || j.message || C.error); return j; });
      }).then(function(j){
        tiles.forEach(function(t){ t.setAttribute('aria-pressed','false'); });
        render();
        if(C.after === 'cart'){ window.location.href = C.cartUrl; return; }
        if(drawer && j.sections && typeof drawer.renderContents === 'function'){
          drawer.classList.remove('is-empty');
          try { drawer.renderContents(j); return; } catch(e){}
        }
        // Update the basket count in the header
        try {
          var html = j.sections && j.sections['cart-icon-bubble'];
          var target = document.getElementById('cart-icon-bubble');
          if(html && target){
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('.shopify-section');
            if(inner) target.innerHTML = inner.innerHTML;
          }
        } catch(e){}
        doneText.textContent = C.added.replace('[count]', n).replace('[total]', money(total, C.moneyFormat));
        done.hidden = false;
      }).catch(function(e){
        render(); msg.textContent = e.message || C.error;
      });
    });
    render();
  }
  function boot(){ [].forEach.call(document.querySelectorAll('[data-lkc]'), init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-lkc]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lekka-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.__lkh) return; root.__lkh = true;
    var D = JSON.parse(root.querySelector('.lkh-data').textContent);
    var ring = root.querySelector('.lkh-ring'), pills = root.querySelector('.lkh-pills');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touch = window.matchMedia && matchMedia('(hover: none)').matches;

    function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
    function lum(h){var n=parseInt(String(h||'#888888').replace('#',''),16);return((n>>16)*299+((n>>8)&255)*587+(n&255)*114)/1000}
    function abs(u){return u && u.indexOf('//')===0 ? location.protocol+u : u}

    var THEMES = (D.themes||[]).map(function(t){return {id:t.id,name:t.name,color:t.color,text:t.text,items:(t.items||[]).map(function(i){i.img=abs(i.img);return i})}});
    var seen = {}, ALL = [];
    THEMES.forEach(function(t){t.items.forEach(function(i){if(!seen[i.url]){seen[i.url]=1;ALL.push(i)}})});
    // In the theme editor, before any collection is chosen, show placeholder cards so the layout is visible.
    if(!ALL.length){
      var demo=['#5d8c4a','#8fb8d8','#2f7f86','#2d5fa8','#d9622b','#f1c84b','#c86b8a','#1f2d4f'];
      for(var k=0;k<12;k++) ALL.push({t:'Choose a collection',img:'',url:'#',p:'',c:demo[k%demo.length]});
    }

    var cur = ALL, cards = [], off = 0, vel = 0, nudge = 0, stepPx = 200, hover = false, drag = false, lx = 0, moved = 0, last = 0, shown = null, visible = true;

    var CROP = {};
    function measure(url, cb){
      if(CROP[url] !== undefined){ if(CROP[url]) cb(CROP[url]); return; }
      var t = new Image(); t.crossOrigin = 'anonymous';
      t.onload = function(){ try{
        var W=160,H=Math.round(160*t.naturalHeight/t.naturalWidth),c=document.createElement('canvas');c.width=W;c.height=H;
        var x=c.getContext('2d',{willReadFrequently:true});x.drawImage(t,0,0,W,H);var d=x.getImageData(0,0,W,H).data;
        function wh(i){return d[i]>228&&d[i+1]>228&&d[i+2]>228}
        function row(y){var n=0;for(var i=0;i<W;i++)if(wh((y*W+i)*4))n++;return n/W>.96}
        function col(q){var n=0;for(var j=0;j<H;j++)if(wh((j*W+q)*4))n++;return n/H>.96}
        var tp=0,bt=H-1,l=0,r=W-1;
        while(tp<H*.2&&row(tp))tp++; while(H-1-bt<H*.2&&row(bt))bt--;
        while(l<W*.2&&col(l))l++; while(W-1-r<W*.2&&col(r))r--;
        var res={l:(l+(l?1:0))/W,t:(tp+(tp?1:0))/H,r:(r+1-(r<W-1?1:0))/W,b:(bt+1-(bt<H-1?1:0))/H,ar:t.naturalHeight/t.naturalWidth};
        CROP[url]=res; cb(res);
      }catch(e){ CROP[url]=null; } };
      t.onerror = function(){ CROP[url]=null; };
      t.src = url;
    }
    function crop(url, im){
      measure(url, function(c){
        if(c.l===0&&c.t===0&&c.r===1&&c.b===1){ im.style.transform='none'; return; }
        var R = parseFloat(getComputedStyle(root).getPropertyValue('--ratio')) || 1.414;
        var wa=c.r-c.l, ha=(c.b-c.t)*c.ar, k=Math.max(1/wa,R/ha);
        im.classList.add('fit');
        im.style.cssText='width:'+(k*100).toFixed(2)+'%;height:'+(k*c.ar/R*100).toFixed(2)+'%;left:'+(50-(c.l+wa/2)*k*100).toFixed(2)+'%;top:'+(50-((c.t+c.b)/2*c.ar)*k/R*100).toFixed(2)+'%';
      });
    }

    function build(){
      ring.innerHTML=''; cards=[];
      var list=[]; while(list.length<18 && cur.length) list=list.concat(cur);
      list.forEach(function(p){
        var a=document.createElement('a'); a.className='lkh-card'; a.href=p.url;
        a.style.setProperty('--c',p.c||'#cfcac0'); a.style.setProperty('--t',lum(p.c)>150?'#1d1d1b':'#f4f1ea');
        var price = D.showPrice && p.p ? (D.pricePrefix ? D.pricePrefix+' ' : '')+p.p : '';
        a.setAttribute('aria-label', p.t + (price ? ', '+price : ''));
        a.innerHTML=(p.img?'<img alt="" draggable="false" loading="lazy" src="'+esc(p.img)+'">':'')+'<span class="fb">'+esc(p.t)+'</span><span class="lkh-cap"><b>'+esc(p.t)+'</b>'+esc(price)+'</span>';
        var im=a.querySelector('img');
        if(im){ im.onerror=function(){im.remove();a.classList.add('noimg')}; if(D.autoCrop) crop(p.img,im); } else a.classList.add('noimg');
        a.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')hover=true});
        a.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse')hover=false});
        a.addEventListener('click',function(e){
          if(moved>6){e.preventDefault();return}
          if(touch && shown!==a){e.preventDefault();if(shown)shown.classList.remove('show');shown=a;a.classList.add('show');hover=true}
        });
        ring.appendChild(a); cards.push(a);
      });
    }

    function frame(t){
      if(!root.isConnected) return;
      var dt=Math.min(50,t-(last||t))/1000; last=t;
      if(visible && cards.length){
        var W=ring.clientWidth, cw=cards[0].offsetWidth, gap=Math.max(10,cw*.1), step=cw+gap, total=cards.length*step;
        stepPx=step;
        var s=Math.min(1,W/1100);
        if(!drag){ off-=(hover||reduce?0:D.speed*dt); off+=vel; vel*=.92; if(Math.abs(vel)<.02)vel=0;
          if(nudge){var m=nudge*Math.min(1,dt*7);off+=m;nudge-=m;if(Math.abs(nudge)<.5){off+=nudge;nudge=0}} }
        var c=W/2;
        for(var i=0;i<cards.length;i++){
          var x=((i*step+off)%total+total)%total-step*2;
          var d=Math.max(-1.4,Math.min(1.4,(x+cw/2-c)/c));
          cards[i].style.transform='translate3d('+x.toFixed(1)+'px,0,'+(D.depth*s*d*d).toFixed(1)+'px) rotateY('+(-d*D.curve*(.55+.45*s)).toFixed(2)+'deg)';
          cards[i].style.zIndex=Math.round(Math.abs(d)*100);
        }
      }
      requestAnimationFrame(frame);
    }

    ring.addEventListener('pointerdown',function(e){drag=true;moved=0;lx=e.clientX;vel=0;ring.classList.add('drag')});
    window.addEventListener('pointermove',function(e){if(!drag)return;var dx=e.clientX-lx;lx=e.clientX;moved+=Math.abs(dx);off+=dx;vel=dx});
    window.addEventListener('pointerup',function(){if(!drag)return;drag=false;ring.classList.remove('drag');if(moved>6&&shown){shown.classList.remove('show');shown=null;hover=false}});
    window.addEventListener('pointercancel',function(){drag=false;ring.classList.remove('drag')});
    ring.addEventListener('wheel',function(e){if(Math.abs(e.deltaX)>Math.abs(e.deltaY)){e.preventDefault();vel-=e.deltaX*.15}},{passive:false});
    document.addEventListener('click',function(e){if(shown&&!ring.contains(e.target)){shown.classList.remove('show');shown=null;hover=false}});
    if('IntersectionObserver' in window) new IntersectionObserver(function(en){visible=en[0].isIntersecting}).observe(root);

    var opts = (D.showAll ? [{id:'all',name:D.allLabel||'All prints',color:D.allColor,text:D.allText,items:ALL}] : []).concat(THEMES.filter(function(t){return t.items.length}));
    if(!opts.length) opts=[{id:'all',name:D.allLabel||'All prints',color:D.allColor,text:D.allText,items:ALL}];
    cur = opts[0].items;
    function select(o,btn){
      if(cur===o.items) return; cur=o.items;
      [].forEach.call(pills.children,function(x){x.setAttribute('aria-pressed',x===btn)});
      shown=null; hover=false; ring.classList.add('swap'); setTimeout(function(){build();ring.classList.remove('swap')},380);
    }
    opts.forEach(function(o,i){
      var b=document.createElement('button'); b.type='button'; b.className='lkh-pill'; b.setAttribute('aria-pressed',i===0); b.dataset.id=o.id;
      b.style.setProperty('--tc',o.color||'#1d1d1b'); b.style.setProperty('--tt',o.text||'#ffffff');
      b.innerHTML=esc(o.name)+(D.showCounts?' <small>'+o.items.length+'</small>':'');
      b.onclick=function(){select(o,b)};
      pills.appendChild(b);
    });
    [].forEach.call(root.querySelectorAll('.lkh-arw'),function(b){b.onclick=function(){nudge+=stepPx*(+b.dataset.dir)}});
    root.__select=function(id){var b=pills.querySelector('[data-id="'+id+'"]');if(b)b.click()};

    build(); requestAnimationFrame(frame);
  }

  function boot(){ [].forEach.call(document.querySelectorAll('[data-lkh]'), init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-lkh]')); });
  document.addEventListener('shopify:block:select', function(e){
    var r=e.target.closest('.shopify-section') && e.target.closest('.shopify-section').querySelector('[data-lkh]');
    if(r && r.__select) r.__select(e.detail.blockId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-formats"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.__lkf) return; root.__lkf = true;
    var track = root.querySelector('.lkf__track');
    var cards = [].slice.call(root.querySelectorAll('.lkf__card'));
    var pills = [].slice.call(root.querySelectorAll('.lkf__pill'));
    var arrows = [].slice.call(root.querySelectorAll('.lkf__arrow'));

    function step(){ var c = cards[0]; if(!c) return 300; var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20; return c.offsetWidth + gap; }
    function updateArrows(){
      var max = track.scrollWidth - track.clientWidth - 2;
      if(arrows[0]) arrows[0].disabled = track.scrollLeft <= 2;
      if(arrows[1]) arrows[1].disabled = track.scrollLeft >= max;
    }
    arrows.forEach(function(a){ a.addEventListener('click', function(){ track.scrollBy({ left: step() * (+a.dataset.dir), behavior: 'smooth' }); }); });
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(updateArrows); }, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    pills.forEach(function(p){
      p.addEventListener('click', function(){
        var f = p.dataset.filter;
        pills.forEach(function(x){ x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
        var first = null;
        cards.forEach(function(c){
          var hit = f === 'all' || c.dataset.finish === f;
          c.classList.toggle('is-dim', !hit);
          c.classList.remove('is-hit');
          if(hit && f !== 'all'){ void c.offsetWidth; c.classList.add('is-hit'); if(!first) first = c; }
        });
        if(first){
          var tr = track.getBoundingClientRect(), fr = first.getBoundingClientRect();
          var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || parseFloat(getComputedStyle(track).paddingLeft) || 0;
          track.scrollBy({ left: fr.left - tr.left - pad, behavior: 'smooth' });
        } else if(f === 'all'){ track.scrollTo({ left: 0, behavior: 'smooth' }); }
      });
    });
  }
  function boot(){ [].forEach.call(document.querySelectorAll('[data-lkf]'), init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-lkf]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-wide-format"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.__lkw) return; root.__lkw = true;
    var track = root.querySelector('.lkw__track');
    var arrows = [].slice.call(root.querySelectorAll('.lkw__arrow'));
    if(!track) return;
    function step(){ var c = track.querySelector('.lkw__card'); if(!c) return 300; return c.offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 20); }
    function update(){
      var max = track.scrollWidth - track.clientWidth - 2;
      if(arrows[0]) arrows[0].disabled = track.scrollLeft <= 2;
      if(arrows[1]) arrows[1].disabled = track.scrollLeft >= max;
    }
    arrows.forEach(function(a){ a.addEventListener('click', function(){ track.scrollBy({ left: step() * (+a.dataset.dir), behavior: 'smooth' }); }); });
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function boot(){ [].forEach.call(document.querySelectorAll('[data-lkw]'), init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ init(e.target.querySelector('[data-lkw]')); });
})();

  } catch(e) { console.error(e); }
})();
})();
